import { Modal } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import Library from './Library'

export default function LibraryModal({ opened, onClose, ...rest }) {
    const isMobile = useMediaQuery('(max-width: 50em)')

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Library"
            size="xl"
            fullScreen={isMobile}
            {...rest}
            styles={{
                title: {
                    fontSize: '1.125rem',
                    fontWeight: 700,
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                },
                body: {
                    padding: 0,
                    height: isMobile ? '100%' : '70vh',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            <Library />
        </Modal>
    )
}

